import type { components } from '@countdown/api-client';
import type { ReactElement } from 'react';

type BackofficeAction = components['schemas']['BackofficeActionView'];

/** The actions a screen of the running season can act on: everything but a draft. */
export function seasonActions(actions: readonly BackofficeAction[]): BackofficeAction[] {
  return actions.filter((action) => action.status !== 'draft');
}

/**
 * The action a season screen opens on (D36: several run side by side): a running one, else the
 * one that ended last, whose winners and mail may still be under way.
 */
export function defaultActionId(actions: readonly BackofficeAction[]): string | null {
  const season = seasonActions(actions);
  const running = season.find((action) => action.status === 'live' || action.status === 'paused');
  const latest = [...season].sort((a, b) => b.ends_on.localeCompare(a.ends_on))[0];
  return (running ?? latest)?.action_id ?? null;
}

/** Which calendar a season screen (emergency stop, prizes) is about. */
export function ActionChoice({
  actions,
  value,
  onChange,
  disabled = false,
}: {
  readonly actions: readonly BackofficeAction[];
  readonly value: string | null;
  readonly onChange: (actionId: string) => void;
  readonly disabled?: boolean;
}): ReactElement | null {
  const season = seasonActions(actions);
  if (season.length < 2) {
    return null;
  }
  return (
    <div className="mb-4 max-w-2xl">
      <label className="block text-sm font-medium" htmlFor="aktion">
        Aktion
      </label>
      <select
        className="mt-1 w-full border border-input bg-background px-3 py-2 text-sm"
        id="aktion"
        value={value ?? ''}
        disabled={disabled}
        onChange={(event) => {
          onChange(event.target.value);
        }}
      >
        {season.map((action) => (
          <option key={action.action_id} value={action.action_id}>
            {action.title}
            {action.status === 'finished' || action.status === 'archived' ? ' (beendet)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
